import { withState } from 'recompose';

export default withState('params', 'updateParams', {
  status: '',
  amountFrom: '',
  amountTo: '',
  amount: '',
});
